import SEGMENT_EVENTS from 'constants/segmentEvents';

function Ctrl($scope, $state, $location, $anchorScroll, $document, $window, $timeout, loggerService,
  utilsService, metaTagService, membershipService, trackingService, modalService, partnerService) {
  $scope.partner = partnerService.partner;
  $scope.defaultCitySlug = utilsService.defaultCitySlug();

  metaTagService.set({
    title: 'Making Nightlife Simple - The #1 app for Bottle Service, Tickets, Guestlist',
    description: 'Tablelist provides instant access to VIP bottle service, private tables and exclusive events in a growing number of cities across the country.',
    facebookTitle: 'Making Nightlife Simple - The #1 app for Bottle Service, Tickets, Guestlist',
    facebookDescription: 'Tablelist provides instant access to VIP bottle service, private tables and exclusive events in a growing number of cities across the country.'
  });

  $scope.navigateTo = function(target) {
    if ($state.includes('app.home')) {
      utilsService.scrollTo(target, 30, 500);
    } else {
      utilsService.link(`/?target=${target}`);
    }
  };

  $scope.isSubscribed = function() {
    return membershipService.isUserSubscribed();
  };

  $scope.goToMembership = function() {
    trackingService.trackEvent(SEGMENT_EVENTS.ClickedHomepageMembershipAd, {});

    $state.go('app.membership.landing');
  };
}

Ctrl.$inject = [
  '$scope',
  '$state',
  '$location',
  '$anchorScroll',
  '$document',
  '$window',
  '$timeout',
  'loggerService',
  'utilsService',
  'metaTagService',
  'membershipService',
  'trackingService',
  'modalService',
  'partnerService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/home/homeCtrl.js